export default __webpack_public_path__ + "static/rate-spread-graph-a697645e8b982fd98c3be13f3452fb13.svg";